import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import i18nIdentify from "../../i18ns/vi/i18nIdentify";

Date.prototype.toJSON = function () {
  var timezoneOffsetInHours = -(this.getTimezoneOffset() / 60); //UTC minus local time
  var sign = timezoneOffsetInHours >= 0 ? "+" : "-";
  var leadingZero = Math.abs(timezoneOffsetInHours) < 10 ? "0" : "";

  //It's a bit unfortunate that we need to construct a new Date instance
  //(we don't want _this_ Date instance to be modified)
  var correctedDate = new Date(
    this.getFullYear(),
    this.getMonth(),
    this.getDate(),
    this.getHours(),
    this.getMinutes(),
    this.getSeconds(),
    this.getMilliseconds(),
  );
  correctedDate.setHours(this.getHours() + timezoneOffsetInHours);
  var iso = correctedDate.toISOString().replace("Z", "");

  return iso + sign + leadingZero + Math.abs(timezoneOffsetInHours).toString() + ":00";
};

class IdentifyAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "merchants";
  apiGeneral = "General";

  /**
   * Hàm lấy danh sách merchant của tài khoản
   */
  getMerchantOfUser() {
    let request = {
      url: `${window._apis[this.apiName]}/merchants/GetByEmail`,
    };
    return httpClient.getAsync(request);
  }
  /**
   *  Lấy dữ liệu danh sách vai trò
   */
  loadMerchantData(id) {
    let url = this.getAPIUrl();
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }
  /**
   *  Lấy dữ liệu danh sách vai trò
   */
  loadMerchantDataIdentify(id) {
    let url = window._apis[this.apiName] + `/profiles/${id}`;
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }
  /**
   *  Lấy dữ liệu danh sách vai trò
   */
  loadMerchantHistorylog() {
    let url = window._apis[this.apiName] + "/historylog/0";
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }
  /**
   * Upload file
   */
  //   submitData(files, identifyData) {
  //     let data = new FormData();
  //     data.append("identifyData", JSON.stringify(identifyData));
  //     for (const [key, value] of Object.entries(files)) {
  //       if (key == "licenseFiles") {
  //         value.forEach((element) => {
  //           data.append(key, element);
  //         });
  //       } else {
  //         data.append(key, value[0]);
  //       }
  //     }
  //     let request = {
  //       url: this.getAPIUrl() + "/identify",
  //       data: data,
  //     };

  //     return this.postAsync(request, false, true, "multipart/form-data");
  //   }

  submitData(id, identifyData) {
    let data = new FormData();
    data.append("identifyData", JSON.stringify(identifyData));
    let request = {
      url: window._apis[this.apiName] + `/profiles/${id}`,
      data: identifyData,
      timeout: 10000,
    };
    return this.putAsync(request);
  }

  /**
   * Update thong tin intergration
   * @param {*} id : id
   * @param {*} intergrationData : thoong tin cap nhat
   * @returns
   */
  updateIntergration(id, intergrationData) {
    let data = new FormData();
    data.append("intergrationData", JSON.stringify(intergrationData));
    let request = {
      url: window._apis[this.apiName] + `/intergrations/merchant/${id}`,
      data: intergrationData,
      timeout: 10000,
    };
    return this.putAsync(request);
  }

  /**
   * Update thong tin registerservice
   * @param {*} id : id
   * @param {*} registerserviceData : thong tin cap nhat
   * @returns
   */
  updateRegisterservice(id, registerserviceData) {
    let data = new FormData();
    data.append("registerserviceData", JSON.stringify(registerserviceData));
    let request = {
      url: window._apis[this.apiName] + `/registerservices/${id}`,
      data: registerserviceData,
      timeout: 10000,
    };
    return this.putAsync(request);
  }

  /**
   * Upload file
   * @param {*} file : File upload
   * @param {*} type : Loại file
   */
  upload(file, type) {
    let data = new FormData();
    data.append("file", file);
    if (type) {
      data.append("type", type);
    }

    let request = {
      url: this.getAPIUrl() + "/file",
      data: data,
    };

    return this.postAsync(request);
  }

  /**
   * Upload nhiều file
   * @param {*} files : File upload
   * @param {*} type : Loại file
   */
  uploads(files) {
    let data = new FormData();
    files.forEach((file) => {
      data.append("files", file, file.name);
    });

    let request = {
      url: this.getAPIUrl() + "/file",
      data: data,
    };
    return this.postAsync(request, false, true, "multipart/form-data");
  }

  /**
   *  Lấy dữ liệu danh sách vai trò
   */
  loadListSector() {
    let url = this.getAPIUrl();
    url = this.getAPIUrl() + "/sector";
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   *  Lấy dữ liệu tỉnh thành, quận huyện
   */
  loadLocationData(kind, id) {
    let url = window._apis["BaseUrlGeneral"] + "/location";
    if (kind == 1) {
      url = url + "?kind=1&parentLocationName=Vi%E1%BB%87t%20Nam";
    } else if (kind == 0) {
      url = url + "?kind=" + kind;
    } else {
      url = url + "?kind=" + kind + "&parentID=" + id;
    }
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Đổi trạng thái user
   */
  //  changeStatus(payload, id) {
  //     let request = {
  //         url: [this.getAPIUrl(), 'users', id].join('/'),
  //         data: payload
  //     };
  //     return httpClient.putAsync(request);
  // }

  /**
   * Trích rút thông tin khách hàng
   * CreatedBy: tmquy (09/07/2021)
   */
  async extractImages(imgs, type) {
    let url = "";
    if (type == i18nIdentify.LicenseFiles) {
      url = this.getAPIUrl() + "/extractLicense";
    } else if (type == i18nIdentify.IdentifyId) {
      url = this.getAPIUrl() + "/extractIdentify";
    }

    let data = new FormData();
    data.append("type", type);
    for (const [key, value] of Object.entries(imgs)) {
      data.append("imageExtract", value);
    }

    let request = {
      url: url,
      data: data,
      timeout: 10000,
    };
    return await this.postAsync(request, true, true, "multipart/form-data");
  }

  /**
   * Lấy thông tin công ty bởi mã thuế
   * CreatedBy: tmquy (13/07/2021)
   */

  async getInforCompanyByTaxCode(taxCode) {
    let url = this.getAPIUrl() + "/extract/" + taxCode;
    let request = {
      url: url,
      timeout: 10000,
    };
    return await this.getAsync(request, false, true, "application/json");
  }

  /**
   *  Lấy dữ liệu merchant
   */
  loadIntergrationsMerchant(code) {
    let url = window._apis[this.apiName] + "/intergrations/" + code; // o
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   *  Lấy dữ liệu merchantservice
   */
  loadMerchantserviceByCode() {
    let url = window._apis[this.apiName] + "/merchantservice/0"; // o
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   *  Thêm mới dịch vụ merchant đăng ký
   */
  insertMerchantService(serviceCode) {
    let url = window._apis[this.apiName] + "/merchantservice?code=" + serviceCode;
    // Build tham số
    let request = {
      url: url,
    };
    // Call api
    return httpClient.postAsync(request);
  }
  /**
   * Kiểm tra đã kích hoạt email chưa
   * CreatedBy: tmquy (14/09/2021)
   */
  checkEmailActive(email) {
    let url = [window._apis.Auth, "/api/account/verification", `?userName=${email}`].join("");
    // let url = this.getAPIUrl() + "/checkEmailActive?email=" + email;

    let request = {
      url: url,
      data: email,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Gửi lại link kích hoạt
   * CreatedBy: tmquy (14/09/2021)
   */
  sendEmailActive(email) {
    let url = this.getAPIUrl() + "/sendEmailActive?email=" + email;
    let request = {
      url: url,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Lấy thông tin lịch sử
   * CreatedBy: tmquy (27/09/2021)
   */
  getHistoryLogByMerchantCode(merchantCode) {
    let url = this.getAPIUrl() + "/historyLog?merchantCode=" + merchantCode;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Tải file lên minio
   * CreatedBy: tmquy (18/10/2021)
   */
  uploadImageMinio(imgs) {
    let url = window._apis["General"] + "/file?bucketName=jetpay";
    let data = new FormData();
    for (let index = 0; index < imgs.length; index++) {
      const file = imgs[index];
      data.append("fileData", file, file.name);
    }
    let request = {
      url: url,
      data: data,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Check mã số thuế đã đang ký hay chưa
   * CreatedBy: tmquy (23/11/2021)
   */
  validateTaxCode(taxCode) {
    let url =
      window._apis[this.apiName] + `/profiles/CheckExistOrganizationCode?orgCode=${taxCode}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Tạo client mới và cập nhật intergration
   * CreatedBy: dbhuan 17/02/2022
   */
  createClientAndUpdateIntergration(merchantCode, identityNumber, webType) {
    let url = `${
      window._apis[this.apiName]
    }/intergrations/client?merchantCode=${merchantCode}&identityNumber=${identityNumber}&webType=${webType}`;
    let request = {
      url,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin plugin mới nhất wp
   * CreatedBy: dbhuan 17/02/2022
   * @returns
   */
  getLastestVersionWp() {
    let url = `${window._apis[this.apiName]}/plugins/wordpress/latest`;
    let request = {
      url,
    };
    return httpClient.getAsync(request);
  }
}

export default new IdentifyAPI();
